import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiscModule, CoreModule } from 'projects/core/src/public-api';
import { ProjectMiscModule } from 'projects/app-misc/src/app/modules/project-misc/project-misc.module';
import { ProjectInfoComponent } from './view/project-info/project-info.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MobileActivitiesComponent } from './view/mobile-blocks/mobile-activities/mobile-activities.component';
import { CustomerModule } from 'projects/desktop/src/app/modules/customer/customer.module';
import { MobileProjectActivityComponent } from './view/mobile-blocks/mobile-activities/mobile-project-activity/mobile-project-activity.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { HomePageModule } from 'projects/desktop/src/app/modules/home-page/home-page.module';

@NgModule({
	declarations: [
		ProjectInfoComponent,
		MobileActivitiesComponent,
		MobileProjectActivityComponent
	],
	entryComponents: [
		ProjectInfoComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TableModule,
		MatDialogModule,
		MatRippleModule,
		MatFormFieldModule,
		MatInputModule,
		MatIconModule,
		MatButtonModule,
		MatSelectModule,
		MiscModule,
		OverlayPanelModule,
		CustomerModule,
		ProjectMiscModule,
		ConfirmDialogModule,
		TooltipModule,
		HomePageModule
	]
})
export class ProjectModule { }
